import { styleOverrides } from "./styleOverrides";

const MuiTableHead = {
  styleOverrides,
};

export { MuiTableHead };
